import { observer } from 'mobx-react'
import { FC, useContext } from 'react'
import './PageHeader.css'
import { StoreContext } from '@store/Root.store'
import { ExternalZoomControls } from '@/components/Generic/PdfViewer/addons/ExternalZoomControls'
import { Header } from '@/components/Generic'
import { Document, GroupWithFiles } from '@components/SignDocumentCommon/types'
import { SignProgress } from '../SignProgress/SignProgress'
import { SignGroupedProgress } from '../SignProgress/SignGroupedProgress'

interface PageHeaderProps {
  header: string
  subHeader?: string
  fileList: Document[]
  currentDocIndex: number
  groups?: GroupWithFiles[]
}
export const PageHeader: FC<PageHeaderProps> = observer(
  ({ header, subHeader, fileList, currentDocIndex, groups }) => {
    const store = useContext(StoreContext)
    if (fileList?.length > 1) {
      return (
        <div className="sign-doc-page-header__multi-doc-container">
          {groups && groups.length > 0 ? (
            <SignGroupedProgress
              currentPage={currentDocIndex + 1}
              documentList={fileList}
              showSubHeader={!!subHeader}
              groups={groups}
            >
              <ExternalZoomControls />
            </SignGroupedProgress>
          ) : (
            <SignProgress
              currentPage={currentDocIndex + 1}
              documentList={fileList}
              showSubHeader={!!subHeader}
            >
              <ExternalZoomControls />
            </SignProgress>
          )}
        </div>
      )
    }

    return (
      <div className="sign-doc-page-header__container">
        <Header className="no-margin text-left">{header}</Header>

        <ExternalZoomControls />
      </div>
    )
  }
)
